import api from './api';

export const activoMantenimientoService = {
    listarProgramaciones: async (diasHorizonte = null) => {
        const params = {};
        if (diasHorizonte !== null) params.dias_horizonte = diasHorizonte;
        const response = await api.get('/programaciones-mantenimiento', { params });
        return response.data;
    },

    obtenerVigente: async (activoId) => {
        const response = await api.get(`/activos/${activoId}/mantenimiento`);
        return response.data;
    },

    historial: async (activoId) => {
        const response = await api.get(`/activos/${activoId}/mantenimiento/historial`);
        return response.data;
    },

    crear: async (activoId, datos, file = null) => {
        const { fecha_vencimiento, fecha_renovacion, tipo, responsable, costo, observaciones } = datos;
        const params = { fecha_vencimiento };
        if (fecha_renovacion) params.fecha_renovacion = fecha_renovacion;
        if (tipo) params.tipo = tipo;
        if (responsable) params.responsable = responsable;
        if (costo !== '' && costo !== null && costo !== undefined) params.costo = costo;
        if (observaciones) params.observaciones = observaciones;

        const formData = new FormData();
        if (file) formData.append('file', file);

        const response = await api.post(`/activos/${activoId}/mantenimiento`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            params,
        });
        return response.data;
    },
};
